import * as React from "react";
import { EventCardProps } from "../EventCard";
import { renderMarketsCountLink } from "../EventCard/RenderMethods";
import * as RenderMethods from "./RenderMethods";
import { getOutrightCountLinkParams, getCardDetailsParams } from "../../../../helpers";
import { observer } from "mobx-react";

@observer
export class LiveOutright extends React.Component<EventCardProps, {}> {
    buttonsHolderClass: string
    componentPrefix: string

    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.componentPrefix = "live-outright";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;

    }

    renderDetails = RenderMethods.renderOutrightDetails;
    renderMarkets = RenderMethods.renderOutrightMarkets;
    getCardDetailsParams = getCardDetailsParams;
    getCountLinkParams = getOutrightCountLinkParams;

    render() {
        return (
            <div className={`rj-ev-list__${this.componentPrefix}`} data-uat={`div-ev-list-${this.componentPrefix}`}>
                {this.renderDetails(this.getCardDetailsParams(this.props),this.componentPrefix)}
                {this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix)}
                {renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix)}
            </div>
        )
    }
}